import React from "react";
import {
  Link as RRLink,
  NavLink as RRNavLink,
  useNavigate as useRRNavigate,
} from "react-router-dom";
import { slashTo } from "../utils/trailingSlash";

/** Link / NavLink that always render internal hrefs with a trailing slash. */
export const Link = React.forwardRef(function Link({ to, ...rest }, ref) {
  return <RRLink ref={ref} to={slashTo(to)} {...rest} />;
});

export const NavLink = React.forwardRef(function NavLink(
  { to, ...rest },
  ref
) {
  return <RRNavLink ref={ref} to={slashTo(to)} {...rest} />;
});

export function useNavigate() {
  const navigate = useRRNavigate();
  return React.useCallback(
    (to, options) =>
      typeof to === "number" ? navigate(to) : navigate(slashTo(to), options),
    [navigate]
  );
}
